const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Mobile Connect Datenerweiterung",
    cellModemIMEI: "Mobiel modem IMEI-nummer",
    siteName: "Name des Systems",
    siteAddress: "Adres systemu",
    cellPlanEndDate: "Enddatum des Cell Modem-Plans",
    daysToExpiry: "Tage bis zum Ablauf",
    currentPlanStatus: "Aktueller Planstatus",
    gatewaySNo: "Gateway-Seriennummer",
    paymentStatus: "Zahlungsstatus",
    lastDateOfPurchase: "Letztes Kaufdatum",
    extendDataPlan: "Datenplan erweitern",
    purchasedBy: "Erworben von",
    purchasedFrom: "Gekauft bei",
    siteId: "System-ID",
    orderNo: "Ordrenummer",
    footer: 'Mobile Connect Datenerweiterung',
    total: 'Gesamt',
    record: 'Aufzeichnungen',
    records: 'Aufzeichnungen',
    show: 'Zeigen',
    enphase_store: 'Enphase Store',
    orderSummary: 'Bestellübersicht.',
    confirmSelection: 'Bitte bestätigen Sie unten Ihre Auswahl',
    noOfCellModems: 'Anzahl der Mobilfunkmodems',
    years: 'Jahre',
    pricePerSite: 'Preis pro Site',
    cancel:'Stornieren',
    submit:'Einreichen',
    back: 'Zurück',
    noTokens: '** Keine Mobilfunkmodems verfügbar **',
    redirectToStoreText: 'Weiterleitung zum Enphase Store! Warten Sie mal...!',
    toolTipExtensionInfo: 'Nur Mobilfunkmodem-Pläne, deren Ablaufdatum weniger als 180 Tage beträgt, sind für eine Verlängerung berechtigt.',
    allCellModems: 'Alle Mobilfunkmodems',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.',
    eligibleCellModems: 'Geeignete Mobilfunkmodems',
    nonAdminInfo: 'Bitte wenden Sie sich an den Administrator, um den Datentarif für ein Mobilfunkmodem zu erweitern',
    select: 'Selecteer',
    typeToSearch: 'Type om te zoeken',
    dataPlanExtensionSuccess: "Die mobile connect datenerweiterung ist erfolgreich. Es kann einige Zeit dauern, bis die Zahlung im Dashboard angezeigt wird",
    expired: 'Abgelaufen',
    active: 'Aktiv',
    failed: "Bezahlung fehlgeschlagen",
    pending: "Zahlungsabwicklung",
    success: "Bezahlung erfolgreich",
  }
}

export default dataPlanExtension